import {all, call, put, takeEvery} from "redux-saga/effects";
import actions from './actions';
import {jsforceResponse} from "@/config/httpService";
import {api} from "@redux/api";

export function* getWaterData() {
    let result = yield call(api.getWater);
    result = jsforceResponse(result, '', false, true)
    console.log('result', result.data.results)
    if (result.status === 200) {
        yield put(actions.WaterSuccess(result.data.results));
    }

}


export function* watchGetWater() {
    yield takeEvery(actions.Water_REQUEST, getWaterData);
}

export default function* WaterSage() {
    yield all(
        [
            watchGetWater()
        ]
    )
}
